"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractReturnsClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const core_auth_1 = require("@deliverr/core-auth");
const client_auth_1 = require("@deliverr/client-auth");
const RETURNS_BASE_URL = process.env.RETURNS_BASE_URL;
class AbstractReturnsClient extends base_client_1.ApiClient {
    constructor(config) {
        if (config.authEngine === core_auth_1.AuthEngine.COGNITO_INTERNAL) {
            const tokenHandler = new client_auth_1.OAuthClientTokenBuilder(config);
            config.tokenRefreshFn = tokenHandler.getTokenFn();
        }
        super({
            ...config,
            baseURL: config.baseURL || RETURNS_BASE_URL,
            authEngine: config.authEngine,
        });
    }
}
exports.AbstractReturnsClient = AbstractReturnsClient;
//# sourceMappingURL=AbstractReturnsClient.js.map